// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    earlyAccessText: {
        type: FIELD_TYPES.TEXT,
        label: "Early Access Text",
        translatable: true
    },
    headingBlack: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    primaryButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Primary Button Text",
        translatable: true
    },
    secondaryButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Secondary Button Text",
        translatable: true
    },
    sectionSubtitleText: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle Text",
        translatable: true
    },
    agentsLogo: {
        type: FIELD_TYPES.NESTED,
        label: "Agents Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    requestEarlyAccessLink: {
        type: FIELD_TYPES.NESTED,
        label: "Request Early Access Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    hideComponent: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Hide Component",
        translatable: false
    }
};
